import { CATEGORY, TASK_STATUS, STAGE } from "@/lib/api";

const STATUS_CLS = {
  assigned: "bg-sky-100 text-sky-800",
  in_progress: "bg-amber-100 text-amber-800",
  pending_spares: "bg-orange-100 text-orange-800",
  completed: "bg-emerald-100 text-emerald-800",
  cancelled: "bg-slate-200 text-slate-600",
};
const CAT_CLS = {
  equipment_service: "border-sky-300 text-sky-700",
  mgps_installation: "border-teal-300 text-teal-700",
  mgps_inspection: "border-teal-300 text-teal-700",
  sales_visit: "border-indigo-300 text-indigo-700",
};
const STAGE_CLS = {
  new: "bg-sky-100 text-sky-800",
  contacted: "bg-indigo-100 text-indigo-800",
  quotation_sent: "bg-amber-100 text-amber-800",
  demo_scheduled: "bg-violet-100 text-violet-800",
  won: "bg-emerald-100 text-emerald-800",
  lost: "bg-rose-100 text-rose-700",
};
export const ATT_CODE = { present: "P", absent: "A", half_day: "HD", on_leave: "L" };
export const ATT_CLS = {
  P: "bg-emerald-100 text-emerald-700",
  A: "bg-rose-100 text-rose-700",
  HD: "bg-amber-100 text-amber-700",
  L: "bg-sky-100 text-sky-700",
};

const pill = "inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap";

export const StatusBadge = ({ status, testid }) => (
  <span data-testid={testid} className={`${pill} ${STATUS_CLS[status] || ""}`}>{TASK_STATUS[status] || status}</span>
);
export const CategoryBadge = ({ category }) => (
  <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${CAT_CLS[category] || ""}`}>
    {CATEGORY[category] || category}
  </span>
);
export const StageBadge = ({ stage, testid }) => (
  <span data-testid={testid} className={`${pill} ${STAGE_CLS[stage] || ""}`}>{STAGE[stage] || stage}</span>
);
const QUOTE_CLS = {
  draft: "bg-slate-100 text-slate-700",
  pending_approval: "bg-amber-100 text-amber-800",
  approved: "bg-emerald-100 text-emerald-800",
  rejected: "bg-rose-100 text-rose-700",
};
const QUOTE_TXT = { draft: "Draft", pending_approval: "Awaiting Approval", approved: "Approved", rejected: "Changes Requested" };
export const QuoteBadge = ({ status, testid }) => (
  <span data-testid={testid} className={`${pill} ${QUOTE_CLS[status] || ""}`}>{QUOTE_TXT[status] || status}</span>
);
export const RoleBadge = ({ role }) => {
  const cls = { staff: "bg-sky-100 text-sky-800", hr: "bg-indigo-100 text-indigo-800", director: "bg-amber-100 text-amber-800" }[role];
  return <span className={`${pill} uppercase ${cls}`}>{role}</span>;
};
